"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabDropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _space = require("../../../styles/variables/_space");
var _classify = require("../../../utils/classify");
var _clickAway = require("../../../utils/click-away");
var _mergeRefs = require("../../../utils/merge-refs");
var _qa = require("../../../utils/qa");
var _Menu = require("../../Menu");
var _Tab = require("../Tab");
var _Tooltip = require("../../Tooltip");
var _TabDropdownModule = _interopRequireDefault(require("./TabDropdown.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TabDropdown = _ref => {
  let {
    anchorPosition = 'bottom-start',
    size,
    onOptionSelect,
    props,
    elevation = 'modal',
    classNames,
    testId
  } = _ref;
  const {
    x,
    y,
    refs,
    strategy,
    context
  } = (0, _react2.useFloating)({
    open: true,
    strategy: 'absolute',
    placement: anchorPosition,
    whileElementsMounted: _react2.autoUpdate,
    middleware: [(0, _react2.shift)(), (0, _react2.flip)(), (0, _react2.offset)(parseInt(_space.spaceXXSmall))]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_clickAway.ClickAway, {
    children: _ref2 => {
      let {
        isOpen,
        onOpen,
        clickAway,
        boundaryRef,
        triggerRef
      } = _ref2;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'dropdown'
        }),
        className: (0, _classify.classify)(_TabDropdownModule.default.tabDropdownContainer, classNames?.wrapper),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tab.Tab, {
          ...props?.tab,
          size: size,
          ref: (0, _mergeRefs.mergeRefs)([refs.setReference, triggerRef]),
          onClick: e => {
            e.stopPropagation();
            onOpen();
          },
          classNames: {
            wrapper: _TabDropdownModule.default.dotTabWrapper,
            iconTextWrap: _TabDropdownModule.default.dotTextWrap
          },
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'dropdown-tab'
          })
        }), isOpen && props?.menu && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingPortal, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingFocusManager, {
            modal: false,
            context: context,
            initialFocus: refs.reference,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ref: (0, _mergeRefs.mergeRefs)([refs.setFloating, boundaryRef]),
              className: _TabDropdownModule.default.menuWrapper,
              "data-testid": (0, _qa.generateTestId)({
                base: testId,
                slot: 'menu-wrapper'
              }),
              style: {
                display: 'flex',
                position: strategy,
                top: y ?? _space.spaceNone,
                left: x ?? _space.spaceNone,
                '--menu-elevation': (0, _Tooltip.getElevationValue)(elevation)
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
                ...props.menu,
                onSelect: (option, e) => {
                  onOptionSelect?.(option, e);
                  clickAway();
                },
                size: props.menu.size || size,
                onTabOut: clickAway,
                testId: (0, _qa.generateTestId)({
                  base: testId,
                  slot: 'menu'
                })
              })
            })
          })
        })]
      });
    }
  });
};
exports.TabDropdown = TabDropdown;